/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Notification from '../common/notification/notification.component';
import { Button } from 'tc-client-common';
import { SPONSOR_NAME, SELECT_BTN, CANCEL_BTN, SIGN_OUT } from '../../const';
import { home } from '../../constants/localUrls';

class SponsorsModal extends Component {
  constructor(props, context) {
    super(props);

    this.confirmSponsor = this.confirmSponsor.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.signOut = this.signOut.bind(this);
  }

  componentDidMount() {
    this.props.loadSponsors(this.props.sponsors);
  }

  confirmSponsor() {
    if (this.props.updatedSponsor !== this.props.selectedSponsor) {
      this.props.selectTenantAndSetCookie(this.props.updatedSponsor);
      this.context.router.history.push(home());
    } else {
      this.props.selectTenantAndSetCookie(this.props.updatedSponsor);
    }
  }

  closeModal() {
    this.props.closeModal();
  }

  signOut() {
    let logoutUrl = this.props.logoutUrl;
    this.props.signOut(logoutUrl);
  }

  render() {
    const { sponsors, selectedSponsor, selectSponsorError, userAllocationsError, updateSponsorSelection } = this.props;

    let body;
    if (userAllocationsError) {
      body = (
        <div>
          <Notification type="error" data={userAllocationsError} />
          <Button id="sign-out-btn" theme="default link" handleClick={this.signOut} label={SIGN_OUT} />
        </div>
      );
    } else {
      body = (
        <div>
          {selectSponsorError && <Notification type="error" data={selectSponsorError} />}
          <form id="SelectSponsorForm" className="form-horizontal">
            <div className="form-group">
              <span className="sponsor-name-label" htmlFor="email">
                {SPONSOR_NAME}:
              </span>
              <select
                id="SponsorList"
                className="form-control sponsor-name-selection"
                defaultValue={selectedSponsor ? JSON.stringify(selectedSponsor) : undefined}
                onChange={updateSponsorSelection}
              >
                <option />
                {sponsors.map((option, id) => {
                  return (
                    <option key={`select-${id}-option-${option.value}`} value={JSON.stringify(option)}>
                      {option.sponsorname}
                    </option>
                  );
                })}
              </select>
            </div>

            <div className="selectsponsor">
              <div className="selectsponsor-btn-group">
                {selectedSponsor && (
                  <Button theme="default large-button" handleClick={this.closeModal} label={CANCEL_BTN} />
                )}
                <Button theme="active large-button" handleClick={this.confirmSponsor} label={SELECT_BTN} />
              </div>
            </div>
          </form>
        </div>
      );
    }

    return <div>{body}</div>;
  }
}

SponsorsModal.propTypes = {
  selectSponsorError: PropTypes.string,
  userAllocationsError: PropTypes.string,
  sponsors: PropTypes.array,
  selectedSponsor: PropTypes.object,
  updatedSponsor: PropTypes.object,
  selectTenantAndSetCookie: PropTypes.func,
  updateSponsorSelection: PropTypes.func,
  loadSponsors: PropTypes.func,
  loadModalWindow: PropTypes.func,
  showModalWindow: PropTypes.func,
  updateLocation: PropTypes.func,
  closeModal: PropTypes.func,
  logoutUrl: PropTypes.string,
  signOut: PropTypes.func
};

SponsorsModal.contextTypes = {
  router: PropTypes.object.isRequired
};

export default SponsorsModal;
